<template class="full-height">
  <div class="member-app-container" style="position: relative; height: 100%">
    <member-data :pageRoles="roles" :title="title" />
  </div>
</template>
<script>
export default {
  name: 'adultTextBlocking',
  components: {
    memberData: () => import('@/views/ita/toursCombine/adultTextBlocking/components/adultTextList.vue'),
  },
  data() {
    return {
      roles: ['TC-USER', 'TC-TRAVEL-LEADER'],
      title: 'TC',
    }
  },
}
</script>
<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
